import { usePublicFetch } from "utils/sdk";

import { IProformaPDF } from "entities/Memo/sdk";

export const usePublicProformaPDFRetrieve = ({
  token,
}: {
  token: string | undefined;
}) =>
  usePublicFetch<IProformaPDF>(
    token ? `v2/deal/token-access/${token}/proforma-pdf/retrieve/` : undefined
  );
